import { useEffect } from 'react'

export const useDarkMode = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const useDarkMode = Boolean(Number(searchParams.get('darkMode')))
    document.body.classList.toggle('vd-theme--use-dark-mode', useDarkMode)
  }, [])
}
